import { render, staticRenderFns } from "./PlusIcon.vue?vue&type=template&id=31ceda0e&scoped=true"
import script from "./PlusIcon.vue?vue&type=script&lang=js"
export * from "./PlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ceda0e",
  null
  
)

export default component.exports